if(!window.theme._registeredSections['header'] === true){
  theme.Header = (function() {


    /**
     * Constructor
     * @todo instantiate outside of slate so we have access to public methods
     */
    function Header(container) {
      
      this.mobileNav = document.querySelector('.header__navigation');

      this.header = container.querySelector('.header');
      if (this.header.classList.contains('header--fixed')) {
        this.isFixed = true;
      } else {
        this.isFixed = false;
      }

      this.mainContent;
      const self = this;
      this.isAnnouncement = false;

      this.filterBarElement = document.querySelector('.collection__tabs');
      this.headerElement = document.querySelector('#shopify-section-header');
      this.headerElementHeight = (this.headerElement) ? this.headerElement.getBoundingClientRect().height : 0;
      this.categorySubnavElement = document.querySelector('#shopify-section-category-subnav');
      this.categorySubnavElementHeight = (this.categorySubnavElement) ? this.categorySubnavElement.getBoundingClientRect().height : 0;
      this.headerHeight = ((this.headerElementHeight) + (this.categorySubnavElementHeight) - 2);

      if (this.isFixed) {
        this.shopifyHeaderSection = stickybits('#shopify-section-header', {
          useStickyClasses: true,
        });

        window.theme._sb_headerSection = this.shopifyHeaderSection;
        if (self.filterBarElement && window.innerWidth < theme.settings.grid_medium) {
          this.filterBar = stickybits(".collection__tabs", {
            stickyBitStickyOffset: this.headerHeight,
            useStickyClasses: true,
            useGetBoundingClientRect: true
          });
        }

        // If there's a filter and the window is small onload unstick the header so the filters can be stuck
        if (self.filterBarElement && window.innerWidth < theme.settings.grid_medium) {
          self.shopifyHeaderSection = stickybits('#shopify-section-header', {
            useStickyClasses: true,
          });
          window.theme._sb_headerSection = this.shopifyHeaderSection;
        }

        window.addEventListener('scroll', function() {
          if (self.filterBarElement && window.innerWidth < theme.settings.grid_medium) {
            self.shopifyHeaderSection = stickybits('#shopify-section-header', {
              useStickyClasses: true,
            });
            window.theme._sb_headerSection = this.shopifyHeaderSection;
          }
        });

        window.addEventListener('resize', () => {
          if( self.shopifyHeaderSection ) self.shopifyHeaderSection.cleanup();
          self.shopifyHeaderSection = stickybits('#shopify-section-header', {
            useStickyClasses: true,
          });
          window.theme._sb_headerSection = this.shopifyHeaderSection;
        });

        window.addEventListener('collection:rendered', () => {
          if( self.shopifyHeaderSection ) self.shopifyHeaderSection.cleanup();
          self.shopifyHeaderSection = stickybits('#shopify-section-header', {
            useStickyClasses: true,
          });
          window.theme._sb_headerSection = this.shopifyHeaderSection;
        });
      }


      window.addEventListener('resize', function() {
        if (window.innerWidth > theme.settings.grid_large) {
          bodyScrollLock.clearAllBodyScrollLocks();
        }

        if (self.filterBarElement) {
          if (window.innerWidth < theme.settings.grid_medium) {
            this.filterBar = stickybits(".collection__tabs", {
              stickyBitStickyOffset: this.headerHeight,
              useStickyClasses: true,
              useGetBoundingClientRect: true
            });
          } else {
            if (this.filterBar) {
              this.filterBar.cleanup();
            }
          }
        }
      });
  
      // Menu toggle
      var btnMenuToggles = container.querySelectorAll('.hamburger--toggle');
      Array.from(btnMenuToggles).forEach((btnMenuToggle) => {
        btnMenuToggle.addEventListener('click', this.btnMenuToggleHandler.bind(self));
      });
      this.bindKeyboardEvents();

      document.addEventListener("click", function (event) {
        const nav = document.querySelector(".header__navigation");
        const btnMenuToggle = document.querySelector(".hamburger--toggle");
        const body = document.body;

        const isClickInsideNav = nav.contains(event.target);
        const isClickOnToggle = btnMenuToggle.contains(event.target);
        if (!isClickInsideNav && !isClickOnToggle && body.classList.contains("menu-is-expanded")) {
          body.classList.remove("menu-is-expanded");
          btnMenuToggle.setAttribute("aria-expanded", "false");
          bodyScrollLock.enableBodyScroll(nav);
        }
      });

      // Search toggle
      var btnSearch = container.querySelector('.header__btn--search');
      $(document).on('keydown:escape', function(e) {
        e.preventDefault();
        e.stopPropagation();
        theme.SearchApp.hideModal();
        self.btnMenuClickCloseHandler();
        self.collapseDropdown();
      });
      btnSearch.addEventListener('click', function(evt) {
        theme.SearchApp.toggleModal();
        self.btnMenuClickCloseHandler();
        self.collapseDropdown();
        evt.currentTarget.setAttribute('aria-expanded', evt.currentTarget.getAttribute('aria-expanded') === 'false' ? 'true' : 'false');
      });

      const ul = document.querySelectorAll('#nav--two');
      
      ul.forEach(function(ul) {
        let liCount = ul.querySelectorAll('li.has-child').length;
    
        if (liCount >  4) {
          ul.querySelectorAll('li.has-child').forEach(function(li) {
            li.classList.add('moreThanFour');
          });
        }
      });

      // Is there a banner on the page?
      let banner;

      if (theme.template.name === 'index') {
        const firstSection = document.querySelector('#MainContent .shopify-section');
        if (firstSection.classList.contains('hero-slider-section')) {
          banner = firstSection;
        }
      } else {
        banner = document.querySelector('.banner:not(.banner--no-image)');
      }

      var menuDropdowns = document.querySelectorAll('.header__navigation--mobile .nav__dropdown');
      if (menuDropdowns) {
        menuDropdowns.forEach(menuDropdown => {
          menuDropdown.addEventListener('click', function(event) {
            event.stopPropagation();
          });
        });
      }

      // Update navigation title offer price to current currency
      var navHeading = '.header__navigation li h5';
      theme.CurrencySwitcher.switchCurrency(navHeading,true);

      // Update navigation links offer price to current currency
      var navlinks = '.header__navigation li a span';
      theme.CurrencySwitcher.switchCurrency(navlinks,true);

      // check for mobile device
      const mobileCheck = function() {
        let check = false;
        (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
        return check;
      };

      const gtaNavlinks = document.querySelectorAll('.nav-image-gta-el');
      if (gtaNavlinks) {
        gtaNavlinks.forEach(function(navlink) {
          navlink.addEventListener('click', function(el) {
            let item_image_alt = null;
            let item_image_src = null;
            if (mobileCheck()) {
              item_image_alt = this.dataset.item_image_alt_mobile;
              item_image_src = this.dataset.item_image_src_mobile;
            } else {
              item_image_alt = this.dataset.item_image_alt_desktop;
              item_image_src = this.dataset.item_image_src_desktop;
            }

            //const promotionEvent = JSON.parse(localStorage.getItem('ga4-promotionView') || '{}');
            const menuNavEventData = {
              event: 'menu_navigation_action',
              interaction_type: 'Click',
              interaction_element: this.dataset.interaction_element,
              menu_navigation_state: {
                item_name: this.dataset.item_name,
                item_hostname: this.dataset.hostname,
                item_pathname: this.dataset.item_pathname,
                item_level: this.dataset.item_level,
                item_image_alt: item_image_alt,
                item_image_src: item_image_src
              }
            };
            window.ga4NavigationClick = menuNavEventData;

            window.pushEvent(menuNavEventData);
            localStorage.setItem('ga4-navigationClick',JSON.stringify(window.ga4NavigationClick));
            //window.pushEvent(Object.assign({}, window.ga4NavigationClick, { ecommerce: promotionEvent }));
          });
        });
      }
    }

    /**
     * Click handler for search button
     */
    Header.prototype.collapseDropdown = function() {
      var activeDropdowns = this.header.querySelectorAll('.nav__item.has-child.is-expanded');
      activeDropdowns.forEach(function(el) {
        if (el) {
          el.classList.remove('is-expanded');
        }
      });
    };

    /**
     * .header__btn--menu click handler
     */
    Header.prototype.btnMenuClickOpenHandler = function() {
      document.body.classList.add('menu-is-expanded');
    };


    /**
     * hamburger close click handler
     */
    Header.prototype.btnMenuClickCloseHandler = function() {
      document.body.classList.remove('menu-is-expanded');
    };

    Header.prototype.bindKeyboardEvents = function() {
      var self = this;
      $(document).on('keydown:escape', function(e) {
        self.navLinkClose(e);
      });

      const navItems = document.querySelectorAll('.nav__item--toggle');
      navItems.forEach(el => {
        el.addEventListener('keydown', (e)=>{
          if( e.key === "Enter" || e.key === "Space" ) {
            // Only prevent default if this element has a dropdown
            const hasDropdown = el.parentElement && el.parentElement.classList.contains('has-child');
            if (hasDropdown) {
              e.preventDefault();
              e.stopPropagation();
              self.navLinkClickHandler(e);
            }
            // If no dropdown, let the default navigation happen
          }
        });
        el.addEventListener('focus', (e)=>{
          self.navLinkClose(e);
        });
      });
    };

    Header.prototype.btnMenuToggleHandler = function() {
      const btnMenuToggles = this.container.querySelectorAll('.hamburger--toggle');

      if (document.body.classList.contains('menu-is-expanded')) {
        document.body.classList.remove('menu-is-expanded');
        Array.from(btnMenuToggles).forEach((btnMenuToggle) => {
          btnMenuToggle.setAttribute('aria-expanded', 'false');
        });
        bodyScrollLock.enableBodyScroll(this.mobileNav);
      } else {
        document.body.classList.add('menu-is-expanded');
        Array.from(btnMenuToggles).forEach((btnMenuToggle) => {
          btnMenuToggle.setAttribute('aria-expanded', 'true');
        });
        if (window.innerWidth < theme.settings.grid_large) {
          bodyScrollLock.disableBodyScroll(this.mobileNav);
        }
      }
      theme.Announcement();

      var self = this;

      // Bind once and reuse the SAME reference: this runs on every hamburger
      // toggle and addEventListener only dedupes identical references. The
      // previous unbound reference left `this` as the clicked element, so
      // `self.navLinkClose` was undefined inside navLinkClickHandler
      // ("Cannot read properties of undefined (reading 'bind')").
      if (!this.navLinkClickHandlerBound) {
        this.navLinkClickHandlerBound = this.navLinkClickHandler.bind(this);
      }
      if (!this.navLinkCloseBound) {
        this.navLinkCloseBound = this.navLinkClose.bind(this);
      }

      var navLinks = this.container.querySelectorAll('.nav__item--toggle');
      navLinks.forEach(function(el) {
        el.addEventListener('click', self.navLinkClickHandlerBound);
      });
      document.body.addEventListener('click', self.navLinkCloseBound);

      // Hide the search modal if it's showing
      if (theme.SearchApp && theme.SearchApp.isVisible) {
        theme.SearchApp.hideModal();
      }
    };


    /**
     * .nav__item.has-child > a click handler
     */
    Header.prototype.navLinkClickHandler = function(event) {
      const clientWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
      const navItem = event.currentTarget.parentElement;
      const navItemLink = event.currentTarget;
      var self = this;
      if (!self.navLinkCloseBound) {
        self.navLinkCloseBound = self.navLinkClose.bind(self);
      }

      if (clientWidth >= Number(theme.settings.grid_medium) && navItem.classList.contains('has-hover')) {
        return false;
      }

      // Hide the search modal if it's showing
      if (theme.SearchApp && theme.SearchApp.isVisible) {
        theme.SearchApp.hideModal();
      }

      // Menu item toggle
      var navLinks = document.querySelectorAll('.nav__item--toggle');

      event.preventDefault();
      event.stopPropagation();

      // event.target.parentElement.classList.toggle('is-expanded');
      if (navItem.classList.contains('is-expanded')) {
        navItem.classList.remove('is-expanded');
        document.body.classList.remove('dropdown-is-active');
        navLinks.forEach(el => el.setAttribute('aria-expanded', false));

        // Restore focus to the trigger
        if (window.theme.lastActiveElement) {
          window.theme.lastActiveElement.focus();
          window.theme.lastActiveElement = null;
        }

        // Remove escape event listener
        $(document).off('keydown:escape', self.navLinkCloseBound);
      } else {
        // Store the currently focused element
        window.theme.lastActiveElement = document.activeElement;

        navLinks.forEach(el => el.parentElement.classList.remove('is-expanded'));
        navItem.classList.add('is-expanded');
        document.body.classList.add('dropdown-is-active');
        navItemLink.setAttribute('aria-expanded', true);

        // Set focus to the first item in the dropdown
        const firstDropdownItem = navItem.querySelector('.nav__dropdown a');
        if (firstDropdownItem) {
          firstDropdownItem.focus();
        }

        // Close on ESC pressed
        $(document).on('keydown:escape', self.navLinkCloseBound);
      }

      return true;
    };

    Header.prototype.navLinkClose = function(event) {
      // var navLinks = document.querySelectorAll('.nav__item--toggle');
      // if (navLinks) {
      //   navLinks.forEach(el => el.parentElement.classList.remove('is-expanded'));
      // }
      if (!event || !event.target.closest('.header__navigation')) {
          const expanded = document.querySelectorAll('.nav__item.has-child.is-expanded');
          expanded.forEach((el) => el.classList.remove('is-expanded'));
        }
    };

    /**
     * .nav__item.has-child button click handler
     */
    Header.prototype.navButtonKeyHandler = function(event) {
      const clientWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
      const navItem = event.currentTarget.parentElement;
      const siblingAnchor = navItem.childNodes[1];
      const thisButton = event.currentTarget;
      if (!this.navLinkCloseBound) {
        this.navLinkCloseBound = this.navLinkClose.bind(this);
      }

      if (clientWidth < Number(theme.settings.grid_medium)) {
        return false;
      }

      // Hide the search modal if it's showing
      if (theme.Search && theme.Search.isVisible) {
        theme.Search.hideModal();
      }

      // Menu item toggle
      var navLinks = document.querySelectorAll('.nav__item--toggle');

      event.preventDefault();
      event.stopPropagation();

      if (navItem.classList.contains('is-expanded')) {
        navItem.classList.remove('is-expanded');
        siblingAnchor.setAttribute('aria-expanded', false);
        thisButton.setAttribute('aria-expanded', false);

        // Restore focus to the trigger
        if (window.theme.lastActiveElement) {
          window.theme.lastActiveElement.focus();
          window.theme.lastActiveElement = null;
        }

        // Remove escape event listener
        $(document).off('keydown:escape', this.navLinkCloseBound);
      } else {
        // Store the currently focused element
        window.theme.lastActiveElement = document.activeElement;

        navLinks.forEach(el => el.parentElement.classList.remove('is-expanded'));
        navItem.classList.add('is-expanded');
        siblingAnchor.setAttribute('aria-expanded', true);
        thisButton.setAttribute('aria-expanded', true);

        // Set focus to the first item in the dropdown
        const firstDropdownItem = navItem.querySelector('.nav__dropdown a');
        if (firstDropdownItem) {
          firstDropdownItem.focus();
        }

        // Close on ESC pressed
        $(document).on('keydown:escape', this.navLinkCloseBound);
      }

      return true;
    };


    /**
     * Offset header for product template
     */
    Header.prototype.headerOffset = function() {
      var headerHeight = this.header.offsetHeight + this.header.offsetTop;
      var mainContent = document.getElementById('MainContent');

      if (window.innerWidth >= Number(theme.settings.grid_large)) {
        mainContent.style.paddingTop = headerHeight + 'px';

      } else {
        mainContent.style.paddingTop = 0;
      }

    };


    /**
     * Fix form on product template
     */
    Header.prototype.fixProductForm = function() {

      const formFiller = document.querySelector('.product-form__filler');
      const formWrapper = document.querySelector('.product-form__wrapper');

      if (formFiller) {
        let topOfForm = formFiller.offsetTop;
        if (window.scrollY >= topOfForm) {
          formWrapper.classList.add('is-fixed');
          formFiller.style.height = formWrapper.offsetHeight + 'px';
        } else {
          formWrapper.classList.remove('is-fixed');
          formFiller.style.height = '0px';
        }
      }
    };

    Header.prototype.bopisStoreFinder = function() {
    //  stock buffer for low stock
      const lowStockBuffer =  2;
      if (!window.theme.bopis.enable) {
        return;
      }
      // console.log('Header::Bopis::StoreFinder');

      let bopisStoresObj = {
        distanceUnit: window.theme.bopis.distanceUnit,
        selectedCountryCode: window.theme.bopis.selectedCountryCode,
        selectedCountryUnit: window.theme.bopis.selectedCountryUnit,
        defaultStoreID: window.theme.bopis.defaultStore,
        stores: [],
        closestStores: [],
        searchRadius:  window.theme.bopis.searchRadius,
        defaultStoreDetails: [],
        maxSearchRadius: 50000.0,
        fiftyPlusRange: 12756000.0,
        fiftyPlusResultLimit: 1,
        storeResultLimit: 50,
        nearestResultShown: false,
        bopisLocationApiURL: window.theme.bopis.locationApiURL,
        bopisStockApiURL: window.theme.bopis.stockApiURL,
        stockBuffer: window.theme.settings.bopis_onestock_buffer ? window.theme.settings.bopis_onestock_buffer : -1,
      };
      // check if the bopis location api and stock api are available
      const hasLocationApi = !!(bopisStoresObj.bopisLocationApiURL);
      const hasStockApi    = !!(bopisStoresObj.bopisStockApiURL);
      const hasShippingApi = !!(window.theme.bopis.shippingStockApiURL);
      let stockDataString = $('.bopis-store-finder-modal').data('bopis-product-stock');
      
      const productSkuStockMap = {};

      if (stockDataString) {
        let skuStockPairs = stockDataString.split(',');
        skuStockPairs.forEach(pair => {
          let parts = pair.split(':');
          if (parts.length === 2) {
            
            const sku = parts[0].trim();
            const stock = parseInt(parts[1].trim(), 10);
            
            productSkuStockMap[sku] = stock;
            }
        });
      }
      console.log("minicart check stock", productSkuStockMap); 
      let noStoresMessage = {
        showing: false,
        htmlID:'no-stores-available',
        htmlInsertLocation: document.querySelector(".bopis-result-content-wrapper")
      }

      let searchInfo = {
        "search_term": '',
        "search_obj": '',
        "stores": [],
        "selected": '',
        "defaultLocation": '',
        "search_type": 'normal',
        "search_radius": '50km',
        "is_fifty_plus": false,
      }

      let locationSet = false;
      localStorage.setItem('userGeolocation', false);
      let coordinates = '';
      switch(window.theme.store) {
        case "US":
          coordinates = '39.946763,-98.639272';
          break;
        case "CH":
          coordinates = '46.818200,8.227500';
          break;
        case "EU":
          coordinates = '48.858951,2.277020';
          break;
        case "GB":
          coordinates = '52.355500,-1.174300';
          break;
        case "SG":
          coordinates = '1.355758,103.863525';
          break;
        case "ZA":
          coordinates = '-30.559500, 22.937500';
          break;
        default:
          coordinates = '-24.994167, 134.866944';
      }

      let coord = coordinates.trim().split(',');
      let defaultLocation = {
        lat: Number(coord[0]),
        lng: Number(coord[1])
      };

      // Handle BOPIS search modal toggle feature
      function toggleBopis() {
      
        let modal = $('[data-bopis-store-finder-modal]');
        let rcTriggers = '[data-bopis-store-finder-trigger]';
        let closeModalButtons = '[data-close-bopis-store-finder]';
        if (!modal.length || !$(rcTriggers).length) return;
      
        $(document).on('click', '[data-bopis-store-finder-trigger]', function (e) {
          e.preventDefault();
            modal.addClass('bopis-store-finder-modal--visible');
            $('.bopis-store-finder-modal__content-search-result-block').removeClass('show-result');
            $('body').addClass('stopScrolling');
            bopisAutoload();
        });

        $(document).on('click', closeModalButtons, function () {
          modal.removeClass('bopis-store-finder-modal--visible');
          $('.bopis-store-finder-modal__content-search-result-block').removeClass('show-result');
          $('body').removeClass('stopScrolling');
          $('.bopis-search-cta').text('Search');
        });
      }

      function bopisAutoload() {
        let _bopisStores = getBopisStoresInfo('_bopisSearchInfo');
        if (_bopisStores) {
          let searchRadius = parseInt(_bopisStores.search_obj.near.distance / 1000);
          searchRadius = (searchRadius < 51) ? searchRadius : 50;
          $('.bopis-address-input-box').val(_bopisStores.search_term);
          $('.bopis-search-result-range').val(searchRadius);
          $('.bopis-search--range-value').val(searchRadius);
          
          bopisStoresObj.stores = _bopisStores.stores;
          defaultLocation.lat = _bopisStores.defaultLocation.lat;
          defaultLocation.lng = _bopisStores.defaultLocation.lng;
          renderNearbyStoresBOPIS(defaultLocation);

          const rangeSlider= document.querySelector('.bopis-search-result-range');
          const rangeValueDisplay = document.querySelector('.bopis-search--range-value');
          
          if(rangeSlider && rangeValueDisplay) {
            rangeSlider.addEventListener('input', function(){
              rangeValueDisplay.value = this.value;
            })
          }
        }
      }
      function getSkuNumber () {
          const skuParagraph = $('#tab-pd').find('p.product-sku');

          if (skuParagraph.length === 0) {
              console.log("cannot find sku");
              return null; 
          }
          const skuContent = skuParagraph.text();
          const fullText = skuContent ? skuContent.toString() : ''; 
          if (!fullText.startsWith('SKU')) {
              console.log("can not find sku number div");
              return null;
          }
          
          const matchResult = fullText.replace('SKU', '').replace('-', '').replace(':', '')
          const skuNumberString = matchResult.trim();
            
          if(skuNumberString) {
          
            return  {
                      "skus": [skuNumberString],
                      "countryCode": window.theme.bopis.selectedCountryCode
                    }
          } else {
              
              return null;
          }
          
      }
      function saveInventoryToLocal(countryCode, skusArray) {
          const STORAGE_KEY = `_bopisShippingInventory_${countryCode}`;
          let storedData = localStorage.getItem(STORAGE_KEY);
          let saveInventoryToStorage = storedData ? JSON.parse(storedData) : { skus: {} };
          if (skusArray && skusArray.length) {
            skusArray.forEach((skuEle) => {
              saveInventoryToStorage.skus[skuEle.item_id] = {
                quantity: skuEle.quantity,
                timestamp: Date.now()
              };
            });
          }
          
          localStorage.setItem(STORAGE_KEY, JSON.stringify(saveInventoryToStorage));
      }
      function getShippingInventoryFromLocal(countryCode, skusArray) {
          const STORAGE_KEY = `_bopisShippingInventory_${countryCode}`;
          const storedData = localStorage.getItem(STORAGE_KEY);
          const TEN_MINUTES_IN_MS = 15 * 60 * 1000; // 10 minutes in milliseconds
          let inventoryData = null;
          if (storedData) {
              try {
                const parsedData = JSON.parse(storedData);
                // Check if data is valid and not expired
                if (skusArray && skusArray.length && parsedData && parsedData.skus) {
                  let readStockData = [];
                  skusArray.forEach(skuEle => {
                    if (parsedData.skus[skuEle] && parsedData.skus[skuEle].timestamp && ((Date.now() - parsedData.skus[skuEle].timestamp) < TEN_MINUTES_IN_MS)) {
                      readStockData.push({
                        item_id: skuEle,
                        quantity: parsedData.skus[skuEle].quantity,
                        timestamp: parsedData.skus[skuEle].timestamp
                      });
                    }
                  });
                  inventoryData = readStockData;

                } else {
                  console.log("Cached inventory data is expired. Fetching new data.");
                }
              } catch (e) {
                console.error("Error parsing stored inventory data:", e);
                // If parsing fails, treat it as no valid stored data
              }
            }

            // If no valid or non-expired data, fetch from API
            if (!inventoryData || inventoryData.length === 0) {
              inventoryData = null;
              console.log("No inventory data fetched.");
            }

            return inventoryData;


      }
      function getSfsInventoryFromApi(defaulSfsBranch,skuArray) {
          if (!bopisStoresObj.bopisStockApiURL) return; 
          const sfsRequestBody = {
            "aggregates": {
              "*": {
                "endpoint_filter": {
                  "ids": [defaulSfsBranch]
                },
                "item_filter": {
                  "ids": skuArray
                }
              }
            },
            "request_name": "in_stock"
          };
          $.ajax({
            type: "POST",
            url: bopisStoresObj.bopisStockApiURL,
            contentType: 'application/json',
            data: JSON.stringify(sfsRequestBody),
            success: function(rawResponse) {
                // console.log('getStoreStockStatus---stockapi---', response, typeof(response));
                let sfsResult = rawResponse;
                if (typeof(rawResponse) == 'string') {
                  sfsResult = JSON.parse(rawResponse);
                }
                // console.log(res, typeof(res), '-----------')
              
                let sfsSkuStockStatus = '';

                  sfsResult.stocks.forEach((checkItem) => {
                      if (checkItem) {
                        const checkStockAndBuffer = parseInt(checkItem.quantity) + bopisStoresObj.stockBuffer;
                        
                        const checkStock = Math.max(0, checkStockAndBuffer);
                        
                        // skuParagraph.data('shipping-stock-qty', checkStock);
                        if (checkStock <= 0 ) {
                          sfsSkuStockStatus = 'out-of-stock';
                        } else if (checkStock <= lowStockBuffer) {
                          sfsSkuStockStatus = 'low-stock';
                        } else {
                          sfsSkuStockStatus = 'in-stock';
                        }
                        
                        return;
                      }
                  })
                displayStockStatus(sfsSkuStockStatus);
              },
            error: function(jqXHR, textStatus, errorThrown) {
                console.error("shipping branch api failed");
            }
          });
      }
      function getStockFromSKU() {
        if (!window.theme.bopis.shippingStockApiURL && !bopisStoresObj.bopisStockApiURL) return;
        const shippingStockQryObj = getSkuNumber();
        const bopisShippingStockApiURL = window.theme.bopis.shippingStockApiURL;
        const bopisDefaultShippingBranch =  window.theme.bopis.defaultShippingBranch ? window.theme.bopis.defaultShippingBranch : '';
        if (shippingStockQryObj && shippingStockQryObj.skus && shippingStockQryObj.countryCode && bopisShippingStockApiURL) {
          let inventoryDataCache = getShippingInventoryFromLocal(shippingStockQryObj.countryCode, shippingStockQryObj.skus);
          if (inventoryDataCache && inventoryDataCache.length > 0) {
            let skuStockStatusFromCache = '';
                    
              const skuParagraph = $('#tab-pd').find('p.product-sku');

              if (skuParagraph.length === 0) {
                  console.log("cannot find sku");
                  return null; 
              }
              
              inventoryDataCache.forEach((checkItem) => {
                  if (checkItem) {

                    const checkStock = checkItem.quantity;
                    skuParagraph.data('shipping-stock-qty', checkStock);     
                    if (checkStock <= 0 ) {
                      skuStockStatusFromCache = 'out-of-stock';
                    } else if (checkStock <= lowStockBuffer) {
                      skuStockStatusFromCache = 'low-stock';
                    } else {
                      skuStockStatusFromCache = 'in-stock';
                    }
                    
                    return;
                  }
              })
              if (shippingStockQryObj && shippingStockQryObj.skus && bopisDefaultShippingBranch) {
                    // if the country is set shipping branch at metaobject, then we will display the stock status by onstock api for specify branch id with buffer.
                  getSfsInventoryFromApi(bopisDefaultShippingBranch, shippingStockQryObj.skus);
              } else {
                // if the country is not set shipping branch at metaobject, then we will not display the stock status by shopify inventory api
                  displayStockStatus(skuStockStatusFromCache);
              }
              const qtySelectors = document.querySelectorAll('.quantity-selector[data-component="QuantitySelector"]');
              Array.from(qtySelectors).forEach((qtySelector) => {
                qtySelector.dispatchEvent(new CustomEvent('updateQuantity', {
                  bubbles: true, // Allow the event to bubble up the DOM
                  cancelable: false
                }));
              })
          } else {
            $.ajax({
                type: "POST",
                url: bopisShippingStockApiURL,
                contentType: 'application/json',
                data: JSON.stringify(shippingStockQryObj), 
                success: function(response) {
                    let res = response; 
                    
                    const shippingStockProcess = res.processData.map(skuItem => {
                      return {
                        item_id: skuItem.sku,
                        quantity: skuItem.inventoryLevels.reduce((sum, level) => {
                            // For each inventory level, access its 'quantities' array.
                            // Use an empty array as fallback if 'quantities' is missing or null.
                            const quantities = level.quantities || [];

                            // Sum up the quantity for each item in the 'quantities' array.
                            const levelQuantitySum = quantities.reduce((levelSum, item) => {
                                // Ensure 'quantity' exists and is a number before adding.
                                return levelSum + (typeof item.quantity === 'number' ? item.quantity : 0);
                            }, 0); // Initialize levelSum to 0

                            return sum + levelQuantitySum;
                        }, 0)
                      }
                      }
                    )
                  
                    let skuStockStatus = '';
                    
                    const skuParagraph = $('#tab-pd').find('p.product-sku');

                    if (skuParagraph.length === 0) {
                        console.log("cannot find sku");
                        return null; 
                    }
                    
                    saveInventoryToLocal(shippingStockQryObj.countryCode, shippingStockProcess);
                    shippingStockProcess.forEach((checkItem) => {
                        if (checkItem) {

                          const checkStock = checkItem.quantity;
                          skuParagraph.data('shipping-stock-qty', checkStock);     
                          if (checkStock <= 0 ) {
                            skuStockStatus = 'out-of-stock';
                          } else if (checkStock <= lowStockBuffer) {
                            skuStockStatus = 'low-stock';
                          } else {
                            skuStockStatus = 'in-stock';
                          }
                          
                          return;
                        }
                    })
                    const qtySelectors = document.querySelectorAll('.quantity-selector[data-component="QuantitySelector"]');
                    Array.from(qtySelectors).forEach((qtySelector) => {
                      qtySelector.dispatchEvent(new CustomEvent('updateQuantity', {
                        bubbles: true, // Allow the event to bubble up the DOM
                        cancelable: false
                      }));
                    })
                  // console.log("check sfs stock 3", skuStockStatus,  skuParagraph.html());
                  if (shippingStockQryObj && shippingStockQryObj.skus && bopisDefaultShippingBranch) {
                    // if the country is set shipping branch at metaobject, then we will display the stock status by onstock api for specify branch id with buffer.
                    getSfsInventoryFromApi(bopisDefaultShippingBranch, shippingStockQryObj.skus);
                  } else {
                    // if the country is not set shipping branch at metaobject, then we will not display the stock status by shopify inventory api
                    displayStockStatus(skuStockStatus);
                  }
                  
                    
                },
                error: function(jqXHR, textStatus, errorThrown) {
                    console.error("inventory api failed");
                }
            });
          }
        }
      }
      function displayStockStatus(newStatus) {
        
          // 1. Select the target div
          // We're using a more specific selector to ensure we target the correct div
          const isAftershipEnableAtPdpPage = window.theme.settings.enable_aftership_eta && $('body').hasClass('template-product');
          const $stockStatusContainer = isAftershipEnableAtPdpPage ? $('.description').find('#bopis-store--shipping-stock-status-pdp-aftership') : $('#location-result').find('.bopis-store--shipping-stock-status');

          // --- Safeguard: Check if the element was found ---
          if ($stockStatusContainer.length === 0) {
              console.log("Stock status container not found. Check your HTML structure or selector.");
              return;
          }  
          // 2. Remove existing status classes and add the new one
          // Use .removeClass() to remove 'low-stock', 'out-of-stock', etc.
          // Then use .addClass() to add the desired new status.
          // We also handle changing the SVG circle color here for visual consistency.

          if (newStatus === 'in-stock') {
              $stockStatusContainer
                  .removeClass('low-stock out-of-stock') // Remove other possible status classes
                  .addClass('hide-in-stock');
            // $stockStatusContainer.find('.icon-stock-status circle').attr('fill', '#008000'); // Green color
              $stockStatusContainer.find('.bopis-stock-status + span').text(''); // Update text

          } else if (newStatus === 'low-stock') {
              $stockStatusContainer
                  .removeClass('hide-in-stock out-of-stock')
                  .addClass('low-stock');
              $stockStatusContainer.find('.icon-stock-status circle').attr('fill', '#FFA500'); // Orange color
              $stockStatusContainer.find('.bopis-stock-status + span').text('Low stock');

          } else if (newStatus === 'out-of-stock') {
              $stockStatusContainer
                  .removeClass('hide-in-stock low-stock')
                  .addClass('out-of-stock');
              $stockStatusContainer.find('.icon-stock-status circle').attr('fill', '#D2140A'); // Red color
              $stockStatusContainer.find('.bopis-stock-status + span').text('Out of stock');       
              
          } else {
              console.log("WARN: Invalid stock status provided: " + newStatus);
          }
        
      }
      function autoloadBopisUSP() {
        
        getStockFromSKU();
      
        var _bopisStores = getBopisStoresInfo('_bopisSearchInfo');
        var selectedStore = [];
        var selectedStoreID = [];
        if(_bopisStores && _bopisStores.selected != '') {
          selectedStore = _bopisStores.stores.filter(function(store) {
            if(store.id == _bopisStores.selected) {
              selectedStoreID.push(store.id);
              return store;
            }
          });
        } else {
          if (!bopisStoresObj.defaultStoreID) {
            return;
          }
          if (!bopisStoresObj.bopisLocationApiURL) { 
            return; 
          } 
          let nearQryObj = {
            "classification": [{"endpoint_type":[["store"]]}],
            "address": {
              "regions": {
                "country": {
                  "code": bopisStoresObj.selectedCountryCode
                }
              }
            },
            "near": {
              "endpoint_id": bopisStoresObj.defaultStoreID,
              "distance": bopisStoresObj.searchRadius
            },
            "pagination": {
                "start": 0,
                "limit": 1
              }
            };
            selectedStoreID.push(bopisStoresObj.defaultStoreID);
            $.ajax({
              type: "POST",
              url: bopisStoresObj.bopisLocationApiURL,
              contentType: 'application/json',
              data: JSON.stringify(nearQryObj),
              async: false,
              success: function(response) {
              // console.log('BOPIS:: autoloadBopisUSP::noobj: ', response);
              //setNearbyStoresDetails(response, searchInfo);
              const resultJson = response && JSON.parse(response) ? JSON.parse(response) : {};
              selectedStore = resultJson.endpoints ? resultJson.endpoints : [];
            },
            error: function(err){
                // console.log(err.responseText);
            }
          });
        
        }

        let uspContent = '';
        let uspContentShortInfo = '';
        let bopis_usp_short_description = window.theme.bopis.usp_short_description ? window.theme.bopis.usp_short_description : "";
        let changeStoreText = '';
        let changeStoreContent = '';
        const bopis_usp_ckc_unavailable_short_desc = window.theme.settings.bopis_usp_unavailable_short_desc ? window.theme.settings.bopis_usp_unavailable_short_desc : "";
        const bopis_usp_ckc_unavailable_desc = window.theme.settings.bopis_usp_unavailable_desc ? window.theme.settings.bopis_usp_unavailable_desc : "";
        const pdp_shipping_usp_desc = window.theme.settings.bopis_usp_description ? window.theme.settings.bopis_usp_description : "";
        let isStoreCkc = false;
        selectedStore.forEach(function(store) {
          uspContentShortInfo = `${ bopis_usp_short_description }`
          isStoreCkc = store && store.modules && store.modules.ckc ? store.modules.ckc : false;
          uspContent = `
          <div class="bopis-store--stock-status bopis-store--${store.id}"></div>
          `;
          changeStoreText = `${store.name}`;
          changeStoreContent = `<div class="bopis-store--stock-status bopis-store--${store.id}"></div>`
        });
        

        // change store text
        $('.bopis-selected-store-short-info a.bopis-change-store-cta.detail').text(changeStoreText);
        
        $('.bopis-block-wrapper .bopis-selected-store-info').html(changeStoreContent);
        getStoreStockStatus(selectedStoreID);
        // check store is support ckc and after check stock status, hide or display the usp content base on the availability
        if (($('.bopis-block-wrapper .bopis-selected-store-info').find('.bopis-store--stock-status').length > 0) && !isStoreCkc) {
          $('.bopis-block-wrapper .bopis-selected-store-short-info .bopis-selected-store-short-info-text').text(bopis_usp_ckc_unavailable_short_desc);
          $('.bopis-block-wrapper .bopis-selected-store-info').find('.bopis-store--stock-status').css('display', 'none');
        } else {
          $('.bopis-block-wrapper .bopis-selected-store-short-info .bopis-selected-store-short-info-text').text(uspContentShortInfo);
        }
        if (isStoreCkc) {
          $('.bopis-selected-store-added-info .bopis-selected-store-added-info-text').text(pdp_shipping_usp_desc);
        } else{
          $('.bopis-selected-store-added-info .bopis-selected-store-added-info-text').text(bopis_usp_ckc_unavailable_desc);
        }
        // console.log('BOPIS:: autoloadBopisUSP: ', selectedStore);    
      }

      /* set store object in local and call render function*/
      function setNearbyStoresDetails (nearbyStores, searchInfo) {
        bopisStoresObj.stores = nearbyStores.endpoints;
        searchInfo.stores = nearbyStores.endpoints;
        // console.log(searchInfo, 'setNearbyStoresDetails');
        setBopisStoresInfo(searchInfo, '_bopisSearchInfo');
        if(searchInfo.is_fifty_plus) {
          //renderFiftyPlusStoreBOPIS(defaultLocation);
        } else {
        }
        renderNearbyStoresBOPIS(defaultLocation);
      }

      function getNearbyStoresDetailsBOPIS(defaultLocation, searchTerm = '', isCKCEnable = false) {
        if (!bopisStoresObj.bopisLocationApiURL) return;
        var _bopisStores = getBopisStoresInfo('_bopisSearchInfo');
        let nearQryObj = {
          "classification": [{"endpoint_type":[["store"]]}],
          "address": {
              "regions": {
                "country": {
                  "code": bopisStoresObj.selectedCountryCode
                }
              }
          },
          "near": {
              "centre_coordinates": {
                  "lat": parseFloat(defaultLocation.lat),
                  "lon": parseFloat(defaultLocation.lng)
              },
              "distance": bopisStoresObj.searchRadius
          },
          "pagination": {
              "start": 0,
              "limit": bopisStoresObj.storeResultLimit
          }
        };
        if (isCKCEnable) {
          nearQryObj = {
            "classification": [{"endpoint_type":[["store"]]}],
            "address": {
                "regions": {
                  "country": {
                    "code": bopisStoresObj.selectedCountryCode
                  }
                }
            },
            "near": {
                "centre_coordinates": {
                    "lat": parseFloat(defaultLocation.lat),
                    "lon": parseFloat(defaultLocation.lng)
                },
                "distance": bopisStoresObj.searchRadius
            },
            "modules": {
              "ckc": true
            },
            "pagination": {
                "start": 0,
                "limit": bopisStoresObj.storeResultLimit
            }
          };
        }

        searchInfo.search_term = searchTerm;
        searchInfo.defaultLocation = defaultLocation;
        searchInfo.search_obj = nearQryObj;
        searchInfo.search_type = 'normal';
        searchInfo.is_fifty_plus = false;
        searchInfo.selected = (_bopisStores && _bopisStores.selected != '')?_bopisStores.selected: '';
        
        // console.log('BOPIS::searchInfo---', searchInfo, _bopisStores);
        $.ajax({
          type: "POST",
          url: bopisStoresObj.bopisLocationApiURL,
          contentType: 'application/json',
          data: JSON.stringify(nearQryObj),
          success: function(response) {
              // console.log('BOPIS:: locationapi ', `${response.endpoints.length} == 0 && ${bopisStoresObj.searchRadius} == ${bopisStoresObj.maxSearchRadius}`);
              const resultJson = response && JSON.parse(response) ? JSON.parse(response) : {};
              if(resultJson && resultJson.endpoints.length == 0 && bopisStoresObj.searchRadius == bopisStoresObj.maxSearchRadius) {
                // Get 50+ search radius results
                getFiftyPlusRangeStore(defaultLocation, searchTerm, isCKCEnable);
              } else {
                const resultJson = response && JSON.parse(response) ? JSON.parse(response) : {};
                if (isCKCEnable && searchInfo.search_obj && searchInfo.search_obj.hasOwnProperty('modules')) {
                    delete searchInfo.search_obj.modules;
                }
                setNearbyStoresDetails(resultJson, searchInfo);
              }
          },
          error: function(err){
              // console.log(err.responseText);
          }
        });

      }

      function getProductMetafieldsInfo() {
        function stringToBoolean(value) {
          if (value === "true") {
            return true;
          } else if (value === "false" || value === "") {
            return false;
          }
          return value; // Return the original value if it's not "true", "false", or ""
        }

        try {
          let getInfo = document.querySelector('.bopis-store-finder-modal').dataset.activeSfs
          let arrayOfStrings = getInfo.split(',');
          let trimmedArray = arrayOfStrings.map(str => str.trim());

          // Step 2: Convert the array of strings into an object
          let variantsData = trimmedArray.reduce((acc, str) => {
            // Split the string into key and value
            let [key, value] = str.split(':').map(s => s.trim().replace(/"/g, ''));
            // Add the key-value pair to the accumulator object
            acc[key] = stringToBoolean(value);
            return acc;
          }, {});

          return variantsData;

        } catch (error) {
          return {};
        };

      }

      function getStoreStockStatus(processedStoreIds) {
        if (!bopisStoresObj.bopisStockApiURL) return; 
        let active_ckc = getProductMetafieldsInfo();
        let productSKU = document.querySelector('.bopis-store-finder-modal').dataset.bopisProductSku;
        let storeIds = [...processedStoreIds];
        const isValidStoreIds = storeIds && storeIds.length ? storeIds.filter(storeId => storeId) : []; 
        if (isValidStoreIds && isValidStoreIds.length === 0) {
          return;
        }
        let _bopisStores = getBopisStoresInfo('_bopisSearchInfo');
        let stockIcon = `<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-stock-status" viewBox="0 0 8 8"><circle cx="4" cy="4" r="4" fill="#D2140A"/></svg>`;
        let  stockQryObj = {
          "aggregates": {
            "*": {
              "endpoint_filter": {
                "ids": storeIds
              },
              "item_filter": {
                "ids": [
                  productSKU
                ]
              }
            }
          },
          "request_name": "in_stock"
        };


        if(active_ckc[productSKU] == false) {
          storeIds.forEach(function(storeId) {
            let stockInfo = `<div class="bopis-store--stock-status bopis-store--${storeId} shipping-only">
              <span class="bopis-stock-status">${ stockIcon }</span>
              <span>Unavailable for Click & Collect</span></div>`;
            let stockEl = `.bopis-store--${storeId}`;
            $(stockEl).html(stockInfo);
          });
        }
        else {

          
          $.ajax({
            type: "POST",
            url: bopisStoresObj.bopisStockApiURL,
            contentType: 'application/json',
            data: JSON.stringify(stockQryObj),
            success: function(response) {
                // console.log('getStoreStockStatus---stockapi---', response, typeof(response));
                if (typeof(response) == 'string') {
                  var res = JSON.parse(response);
                }
                // console.log(res, typeof(res), '-----------')
                let stocks = res.stocks;
              
                // console.log('+++++',storeIds, stocks, res["stocks"], res.stocks ,' stocks.length');
                
                storeIds.forEach(function(storeId) {
                  let currentStoreStock = [];
                  // console.log('+++++',storeId, stocks, stocks.length);
                  if(stocks.length) {
                    currentStoreStock = stocks.filter((store) => store.endpoint_id == storeId);
                  }
                  let stockQuantity = 0;
                  let stockInfo = `<div class="bopis-store--stock-status bopis-store--${storeId} out-of-stock">
                    <span class="bopis-stock-status">${ stockIcon }</span>
                    <span>Out of stock</span></div>`;
                  let stockEl = `.bopis-store--${storeId}`;
                  if(currentStoreStock.length) {
                    stockQuantity = parseInt(currentStoreStock[0].quantity) + bopisStoresObj.stockBuffer;
                    // console.log('currentStoreStock:: ', currentStoreStock, ' afterBuffer:: ',stockQuantity);
                    //    stockBuffer
                  
                    if (stockQuantity == 0) {
                      stockInfo = `<div class="bopis-store--stock-status bopis-store--${storeId} out-of-stock">
                    <span class="bopis-stock-status">${ stockIcon }</span>
                    <span>Out of stock</span></div>`;
                    }
                    else if (stockQuantity < 3) {
                      stockInfo = `<div class="bopis-store--stock-status bopis-store--${storeId} low-stock">
                        <span class="bopis-stock-status">${ stockIcon }</span>
                        <span>Low stock</span></div>`;
                    } else {
                      stockInfo = ``;
                    }
                  }
                  $(stockEl).html(stockInfo);
                  // console.log(stockInfo);
                  // check the list store which is not ckc store will not display stock and ckc store will display stock result.
                  let ckcStoreTargetSelector = `div.bopis-store--${storeId}[data-store-ckc="true"]`;
                  let ckcUnavailableTargetSelector = `div.bopis-store--${storeId}[data-store-ckc="false"]`;
                  const $stockStatusElement = $(ckcStoreTargetSelector);
                  
                  if ($stockStatusElement.length > 0) {
                      $stockStatusElement.html(stockInfo);
                  } else {
                      stockInfo = `<div class="bopis-store--stock-status bopis-store--${storeId} shipping-only">
                        <span class="bopis-stock-status">${stockIcon}</span>
                        <span>Unavailable for Click & Collect</span></div>`;
                      
                      $(ckcUnavailableTargetSelector).html(stockInfo);
                  }
                  // $(stockEl).html(stockInfo);
                  // stockEl
                  // console.log(currentStoreStock, currentStoreStock.length, stockQuantity);
                });

            },
            error: function(err){
                // console.log(err.responseText);
            }
          });
        }
      }


      // Get 50+ search radius stores data 
      function getFiftyPlusRangeStore(defaultLocation, searchTerm = '', isCKCEnable = false) {
        if (!bopisStoresObj.bopisLocationApiURL) return; 
        let nearQryObj = {
          "classification": [{"endpoint_type":[["store"]]}],
          "address": {
              "regions": {
                "country": {
                  "code": bopisStoresObj.selectedCountryCode
                }
              }
          },
          "near": {
            "endpoint_id": null,
            "centre_coordinates": {
              "lat":defaultLocation.lat,
              "lng":defaultLocation.lng
            },
            "distance": bopisStoresObj.fiftyPlusRange
          },
          "pagination": {
              "start": 0,
              "limit": bopisStoresObj.fiftyPlusResultLimit
          }
        };
        if (isCKCEnable) {
          nearQryObj = {
            "classification": [{"endpoint_type":[["store"]]}],
            "address": {
              "regions": {
                "country": {
                  "code": bopisStoresObj.selectedCountryCode
                }
              }
            },
            "near": {
              "endpoint_id": null,
              "centre_coordinates": {
                "lat":defaultLocation.lat,
                "lng":defaultLocation.lng
              },
              "distance": bopisStoresObj.fiftyPlusRange
            },
            "modules": {
              "ckc": true
            },
            "pagination": {
                "start": 0,
                "limit": bopisStoresObj.fiftyPlusResultLimit
            }
          };
        }

        searchInfo.search_term = searchTerm;
        searchInfo.defaultLocation = defaultLocation;
        searchInfo.search_obj = nearQryObj;
        searchInfo.search_type = 'fiftyPlus';
        searchInfo.is_fifty_plus = true;

        // console.log('BOPIS:: getFiftyPlusRangeStore :: searchInfo', searchInfo);

        $.ajax({
          type: "POST",
          url: bopisStoresObj.bopisLocationApiURL,
          contentType: 'application/json',
          data: JSON.stringify(nearQryObj),
          success: function(response) {
            if (isCKCEnable && searchInfo.search_obj && searchInfo.search_obj.hasOwnProperty('modules')) {
              delete searchInfo.search_obj.modules;
            }
            const resultJson = response && JSON.parse(response) ? JSON.parse(response) : {};
            setNearbyStoresDetails(resultJson, searchInfo);
          },
          error: function(err){
              // console.log(err.responseText);
          }
        });
      }

      // console.log('BOPIS::_bopisStores:: localstorage', _bopisStores);
      // console.log('BOPIS::_bopisStores::bopisStoresObj', bopisStoresObj);
  function renderNearbyStoresBOPIS (defaultLocation) {
        var _bopisStores = getBopisStoresInfo('_bopisSearchInfo');
        var bopisstores = _bopisStores.stores;
        var kmRadius = _bopisStores.is_fifty_plus ? bopisStoresObj.fiftyPlusRange : bopisStoresObj.searchRadius;  
        var radiusInMeters;
        if (bopisStoresObj.selectedCountryUnit === 'miles') {
        radiusInMeters = kmRadius * 1609.34;
        } else {
        radiusInMeters = kmRadius * 1000;
        }


        var closestStores = [];
        var allStores = document.querySelectorAll('.bopis-store--address-container');
        var storeWrapper = document.querySelector('.bopis-result-content-wrapper');
        var resultcount = document.querySelector('.bopis-search-result-count');
        var storeContent = '';

        if (allStores) {
          allStores.forEach(function(store) {
            store.style.display = 'none';
          });
        }
        var currentLocation = new google.maps.LatLng(defaultLocation.lat, defaultLocation.lng);

        bopisstores.forEach(function(store) {
      
          var storeLocation = new google.maps.LatLng(store.address.coordinates.lat, store.address.coordinates.lon);
          var currentDistance = google.maps.geometry.spherical.computeDistanceBetween(currentLocation, storeLocation);
          var storeDetails;
          var storeDistance;
          
          if (currentDistance < radiusInMeters) {
          var displayDistance = (bopisStoresObj.selectedCountryUnit === 'miles')
          ? (currentDistance * 0.000621371192).toFixed(2)
          : (currentDistance / 1000).toFixed(2);

          closestStores.push({
          store: store,
          distance: displayDistance
        });
      }
    });

    if (closestStores.length) {
      if (noStoresMessage.showing) {
        $("#" + noStoresMessage.htmlID).hide();
        noStoresMessage.showing = false;
      }

      var sortedStores = closestStores.sort(function(a, b) {
        return parseFloat(a.distance) - parseFloat(b.distance);
      });

          // console.log('BPOIS::sortedStores',sortedStores);

          // Track processed store IDs
          var processedStoreIds = new Set();

          sortedStores.forEach(sortedStore => {
            // Check if store ID is already processed
              if (processedStoreIds.has(sortedStore.store.id)) return; 
              processedStoreIds.add(sortedStore.store.id);

            let {
              id,
              name,
              address,
              open,
            } = sortedStore.store;

            let {
              distance
            } = sortedStore;
            /*let stockStatus = ($('body').hasClass('template-product')) ? `<div class="bopis-store--stock-status bopis-store--${id} out-of-stock">
            <span class="bopis-stock-status">${stockIcon}</span>
            <span>Out of stock</span></div>`: ``;*/
            
            let _selectedStore = (_bopisStores && _bopisStores.selected == id)? ' active' : '';

            
            storeContent += `
              <div class="bopis-store--address-container${_selectedStore}" data-storeid="${id}">
                <div class="bopis-store--address-block">
                  <div class="bopis-store--address-block-info">
                    <input type="radio" id="bopis-radio-store-${id}" ${(_bopisStores && _bopisStores.selected == id)?`checked`:`` } class="bopis-radio-store-address" name="store-address" value="${id}">
                    <label for="bopis-radio-store-${id}"></label>
                  </div>
                  <div class="bopis-store--address-block-display">
                    <div class="bopis-store--address-block-header">
                      <span class="bopis-store--address-name">${name}</span>
                      <span class="bopis-store--address-distance">${distance}${bopisStoresObj.selectedCountryUnit}</span>
                    </div>
                    <div class="bopis-store--address-details">
                      <div class="bopis-store--address-info">
                      ${address.lines}, ${address.city}, ${address.zip_code}
                      </div>
                    </div>
                    ${sortedStore.store && sortedStore.store.modules && sortedStore.store.modules.ckc ? `<div class="bopis-store--address-details-tag"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="stroke: unset;">
                      <rect x="0.4" y="0.4" width="23.2" height="23.2" rx="11.6" stroke="#999999" stroke-width="0.8"/>
                      <path d="M10.8215 11.6391C10.7243 11.2816 11.0905 10.9744 11.4256 11.1322L16.4532 13.4989C16.74 13.6339 16.7902 14.0208 16.5474 14.2246L12.9775 17.22C12.7347 17.4238 12.3624 17.3072 12.2792 17.0013L10.8215 11.6391Z" fill="white"/>
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M11.6262 10.5496C10.7884 10.1552 9.87307 10.9233 10.116 11.8168L11.5738 17.179C11.7817 17.9438 12.7123 18.2354 13.3195 17.726L14.6054 16.6469L15.75 18.011C15.9813 18.2866 16.3922 18.3226 16.6679 18.0913C16.9435 17.86 16.9794 17.4491 16.7482 17.1735L15.6036 15.8094L16.8893 14.7305C17.4964 14.2211 17.3709 13.2539 16.6538 12.9163L11.6262 10.5496ZM12.742 16.5096L11.4967 11.9287L15.7917 13.9506L12.742 16.5096Z" fill="#999999"/>
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M8.30161 6.34021C8.52211 6.15519 8.85085 6.18395 9.03587 6.40445L10.4892 8.1364C10.6742 8.3569 10.6454 8.68564 10.4249 8.87066C10.2044 9.05569 9.87567 9.02692 9.69065 8.80642L8.23737 7.07447C8.05235 6.85397 8.08111 6.52523 8.30161 6.34021ZM6.67563 9.38238C6.79718 9.12146 7.10723 9.00847 7.36815 9.13002L8.90552 9.84616C9.16645 9.96771 9.27943 10.2778 9.15789 10.5387C9.03635 10.7996 8.7263 10.9126 8.46537 10.791L6.928 10.0749C6.66708 9.95336 6.55409 9.6433 6.67563 9.38238ZM11.5799 5.26718C11.858 5.19279 12.1437 5.3579 12.2181 5.63597L12.6564 7.27434C12.7308 7.55241 12.5657 7.83813 12.2876 7.91251C12.0096 7.9869 11.7238 7.82179 11.6495 7.54373L11.2112 5.90535C11.1368 5.62729 11.3019 5.34157 11.5799 5.26718ZM6.60606 13.3758C6.50753 13.1053 6.64689 12.8062 6.91734 12.7076L7.98046 12.3203C8.25091 12.2218 8.55004 12.3611 8.64857 12.6316C8.74711 12.902 8.60775 13.2012 8.3373 13.2997L7.27418 13.687C7.00373 13.7856 6.7046 13.6462 6.60606 13.3758ZM15.3415 6.04583C15.5908 6.18984 15.6761 6.50862 15.5321 6.75785L14.966 7.73756C14.822 7.98679 14.5032 8.07209 14.254 7.92809C14.0047 7.78408 13.9194 7.4653 14.0634 7.21607L14.6295 6.23637C14.7735 5.98713 15.0923 5.90183 15.3415 6.04583Z" fill="#999999"/>
                      </svg>
                    </div>` : ``}
                <div class="bopis-store--${id}" data-store-ckc="${sortedStore.store && sortedStore.store.modules && sortedStore.store.modules.ckc ? true : false }" ></div>
                <div class="bopis-store--address-details-cta-block">
                  <a href="/pages/store-locator" class="bopis-store--address-details-cta">Store details</a>
                </div>
              </div>
            </div>
          </div>
        `;

          // Mark this store ID as processed
            processedStoreIds.add(sortedStore.store.id);
          });

          resultcount.innerHTML = `${closestStores.length} stores near you`; 
          storeWrapper.innerHTML = storeContent;

          if($('body').hasClass('template-product')) {
          getStoreStockStatus(processedStoreIds);
          }

          $(document).on('click', '.bopis-store--address-container', function() {
            let _selectedStoreID = $(this).data('storeid');
            let _bopisStores = getBopisStoresInfo('_bopisSearchInfo');
            _bopisStores.selected = _selectedStoreID;
            setBopisStoresInfo(_bopisStores, '_bopisSearchInfo');
            // console.log('--------------------------------------------');
            $('.bopis-store--address-container').removeClass('active');
            $('.bopis-radio-store-address').prop('checked', false).attr('checked', false);
            $(this).addClass('active');

            $(this).find('.bopis-radio-store-address').prop('checked', true).attr('checked', true);
          });

        } else {
          var rawRadius = bopisStoresObj.searchRadius;
          var isMiles = bopisStoresObj.selectedCountryUnit === 'miles';

          var displayRadius = isMiles ? Math.floor(rawRadius * 0.00063) : Math.floor(rawRadius / 1000);
          var unit = isMiles ? 'miles' : 'km';
          resultcount.innerHTML = `${closestStores.length} stores near you`; 
          storeWrapper.innerHTML = storeContent;
          noStoresMessage.htmlInsertLocation.innerHTML = `<div class="bopis-store--address-container" id="no-stores-available" style="width:100%; text-align:center;"> Apologies, no stores are available within ${displayRadius} ${unit} of your location</div>`;
          $("#" + noStoresMessage.htmlID).show();
          noStoresMessage.showing = true;
        }
        $('.bopis-search-cta').text('Select Store');
        $('.bopis-store-finder-modal--visible .bopis-store-finder-modal__content-search-result-block').addClass('show-result');

      }

      function setBopisStoresInfo(store, key) {
        localStorage.setItem(key, JSON.stringify(store));
      }

      function getBopisStoresInfo(key) {
        return JSON.parse(localStorage.getItem(key));
      }

      let bopisInputBox = document.querySelector('.bopis-address-input-box');
      let bopisAutocomplete = new google.maps.places.Autocomplete(bopisInputBox);
      let ckcFilterEnable = false;
    

      bopisAutocomplete.addListener('place_changed', function() {
        locationSet = true;
        // console.log('BOPIS:: defaultLocation---:: ', defaultLocation);
        let place = bopisAutocomplete.getPlace();
        defaultLocation.lat = place.geometry.location.lat();
        defaultLocation.lng = place.geometry.location.lng();
        // console.log('BOPIS:: place_changed---:: ', place, defaultLocation);
        let addcomponents = place.address_components;
        setBopisStoresInfo(addcomponents, '_addComponents');
        // console.log('bopis:: ac:: ', addcomponents);
        getNearbyStoresDetailsBOPIS(defaultLocation, place.formatted_address, ckcFilterEnable);
      });

        // add sku change event listerner.
        $(function() {
            $('.product-size-option').on('change', 'input[type="radio"]', function() {  
              setTimeout(() => {
                  getStockFromSKU();
              }, 100);
            });
        });

        // Handle search button click functionality
        $(document).on('click', '.bopis-search-cta', function(e) {
          e.preventDefault();
          if($('.bopis-store--address-container').hasClass('active')) {
            let _selectedStoreID = $('.bopis-store--address-container.active').data('storeid');
            let _bopisStores = getBopisStoresInfo('_bopisSearchInfo');
            let _bopisInteractionCount = localStorage.getItem('_bopisInteractionCount');
            let _addComponents = getBopisStoresInfo('_addComponents');
            let _locationData = {};
            // let selectedStoreInfo = _bopisStores.stores.filter(function(store) {
            //   if(store.id == _selectedStoreID) {
            //     return store;
            //   }
            // });

            if(_addComponents) {
              _addComponents.filter(function(parts) {
                if(parts.types.includes("postal_code") || parts.types.includes("country")) {
                  if(parts.types.includes("postal_code")) {
                    _locationData.zip = parts.short_name;
                  } else {
                    _locationData.region = parts.short_name;
                  }
                }  
              });
            }

            window.pushEvent({
              event: 'delivery_estimate_action',
              interaction_type: 'Location Added', // or Location Selected
              delivery_estimate_state: {
                interaction_count: ((_bopisInteractionCount)? (parseInt(_bopisInteractionCount) + 1) : 1),
                option_name: 'Click & Collect', // or Shipping, or Ship to Store
                location_data: _locationData, // this is parsed from the input field
              },
            });

            localStorage.setItem('_bopisInteractionCount', ((_bopisInteractionCount)? (parseInt(_bopisInteractionCount) + 1) : 1));
            // console.log('bopis:: DL::window.dataLayer ', window.dataLayer);
            _bopisStores.selected = _selectedStoreID;
            setBopisStoresInfo(_bopisStores, '_bopisSearchInfo');
            if($('body').hasClass('template-product')) {
              autoloadBopisUSP();
            }
            if(window.location.pathname && window.location.pathname === '/cart') {
              theme.cartPage.refreshStockData('click-and-collect', true);
            }
            $('[data-close-bopis-store-finder]').trigger('click');
          }
        });

        // handle use current location feature
        $(document).on('click', '.bopis-use-current-location-cta', function(e) {
          e.preventDefault();
          
          if(navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function(position) {
              defaultLocation = {
                lat: position.coords.latitude,
                lng: position.coords.longitude
              };
              
              localStorage.setItem('userGeolocation', true);
              localStorage.setItem('userCoordinates', JSON.stringify(defaultLocation));
          getNearbyStoresDetailsBOPIS(defaultLocation, '', ckcFilterEnable);
            });
            //$('.bopis-store-finder-modal__content-search-result-block').addClass('show');
          } else {
            localStorage.setItem('userGeolocation', false);
          }
        });

        // handle search result range feature
        $(document).on('change', '.bopis-search-result-range', function(e) {
              const rawValue = parseInt(this.value);
              const unit = bopisStoresObj.selectedCountryUnit; 
        $('.bopis-search--range-value').val(rawValue);
        if (unit === 'miles') {
        bopisStoresObj.searchRadius = rawValue * 1609;
        } else {
        bopisStoresObj.searchRadius = rawValue * 1000;
        }
        const searchTerm = $('.bopis-address-input-box').val();
          getNearbyStoresDetailsBOPIS(defaultLocation, searchTerm, ckcFilterEnable);
        });

        // handle click and collect store filter toggle button
        $(document).on('click', '#myClickButton', function(e) {
          e.preventDefault();
          $(this).toggleClass('active');
          const _bopisStores = getBopisStoresInfo('_bopisSearchInfo');
          const isValidCoordinates = _bopisStores && _bopisStores.search_obj && _bopisStores.search_obj.near && _bopisStores.search_obj.near.centre_coordinates ? 
          _bopisStores.search_obj.near.centre_coordinates : null;
          
          const isValidCoordinatesObj = isValidCoordinates && ((isValidCoordinates.lat && isValidCoordinates.lon) ||  (isValidCoordinates.lat && isValidCoordinates.lng) )? 
          {
            lat: isValidCoordinates.lat,
            lng: isValidCoordinates.lon || isValidCoordinates.lng
          } : null;
          
          if($('#myClickButton').hasClass('active')) {
            if (isValidCoordinatesObj) {
              getNearbyStoresDetailsBOPIS(isValidCoordinatesObj, '', true);
            }
            ckcFilterEnable = true;
            
          } else {
            if (isValidCoordinatesObj) {
              getNearbyStoresDetailsBOPIS(isValidCoordinatesObj, '', false);
            }
            ckcFilterEnable = false;
            
          }
        });

      toggleBopis();
      if($('body').hasClass('template-product')) {
        autoloadBopisUSP();
      }
    };


    return Header;

  })();

  window.theme.sections.register('header', theme.Header);
  window.theme._registeredSections['header'] = true;
}